export default {
  quote: {
    di_ID: '',
    de_initial_equity_target_pct: '',
    de_exit_equity_target_pct: '',
    de_initial_wholesale_value: '',
    de_exit_wholesale_value: '',
    de_total_payments: 72,
    de_advance_payments: '',
    de_remaining_payments: '',
    de_loan_funding_cost: '',
    de_lease_funding_cost_pct: '',
    de_state_of_registration: '',
    de_state_tax_rate_pct: '',
    de_county_tax_rate_pct: '',
    de_zip_tax_rate_pct: '',
    de_net_pay_dealer: '',
    de_pay_dealer_dmv_fees: '',
    de_tx_tax_pd_by_dealer: '',
    de_is_trade_tax_exempt: '',
    de_first_ach: '',
    de_last_ach: '',
    vd_vehicle_price: '',
    vd_dealer_txn_fee: '',
    vd_total_price: '',
    vd_cash_cap_reduction: '',
    vd_trade_value: '',
    vd_trade_payoff: '',
    vd_trade_credit: '',
    vd_total_cap_reduction: '',
    vd_lease_cap_cost: '',
    vd_llp_initial_residual: '',
    vd_llp_residual_adjustment: '',
    vd_llp_final_residual: '',
    vd_residual_revenue: '',
    vd_lease_residual: '',
    ld_initial_pre_tax_lease_payment: '',
    ld_adj_to_monthly_lease_payment: '',
    ld_final_pre_tax_monthly_lease_payment: 0,
    ld_tax_on_monthly_lease_payment: 0,
    ld_final_monthly_lease_payment: 0,
    ld_upfront_lease_payment_due: 0,
    ld_total_cap_cost_reduction: 0,
    ld_tax_due_at_inception: 0,
    ld_acquisition_fee: '',
    ld_service_contract_fee: '',
    ld_tax_on_fees: '',
    ld_dealer_fee: '',
    ld_est_dmv_fee: '',
    ld_security_deposit: '',
    ld_other: '',
    ld_total_due_upon_signing: '',
    ld_less_trade_credit: '',
    ld_less_dealer_deposit: '',
    ld_cash_due_upon_signing: '',
    ld_sum_of_lease_payments: '',
    ld_depreciation: '',
    ld_sum_of_pre_tax_lease_payments: '',
    ld_total_rental_charge: '',
    ld_tax_on_initial_lease_payments: '',
    ld_monthly_depreciation: '',
    ld_monthly_depreciation: '',
    vd_monthly_depreciation: '',
    at_inception: 30000,
    at_month_12: 28000,
    at_month_24: 20000,
    at_month_36: 15500,
    at_month_48: 10500,
    at_month_58: 5000,
    at_month_72: 5000,
    at_wtd_average: 114500,
    lm_loan_amount: '',
    lm_loan_payment_estimate: '',
    lm_origination_revenue: '',
    lm_origination_reserve: '',
    lm_origination_income: '',
    lm_annuity_revenue_monthly: '',
    lm_annuity_reserve_monthly: '',
    lm_annuity_income_monthly: '',
    lm_annuity_revenue_life_of_lease: '',
    lm_annuity_reserve_life_of_lease: '',
    lm_annuity_income_life_of_lease: '',
    lm_total_revenue_life_of_lease: '',
    lm_total_reserve_life_of_lease: '',
    lm_total_income_life_of_lease: '',
    lm_tax_due_on_cash_cap_red: '',
    lm_tax_due_on_pmts_cap_cost: '',
    lm_tax_on_trade: '',
    lm_quote_id: '',
    lm_lease_type: '',
    lm_vehicle_apprised_value: '',
    lm_quote: new Date(),
    lm_quote_valid_days: '',
    lm_proposed_lessee_name: '',
    lm_dealer_name: '',
    lm_person_receiving_quote: '',
    lm_selling_price_lm: '',
    lm_year: '',
    lm_make: '',
    lm_model: '',
    lm_trim: '',
    lm_miles: '',
    lm_color: '',
    lm_vin: '',
    lm_style: '', // will add extra column to db table
    lm_curb_weight: '', // will add extra column to db table
    lm_original_msrb: '', // will add extra column to db table
    lm_fuel_type: '', // will add extra column to db table
    credit_score: '',
    lm_loan_amount_lm: '',
    lm_source: '',
    lm_sales_agent: '',
    lm_inhouse_category: '',
    lm_quote_state: '',
    lm_quote_converted: '',
    lm_quote_status: '',
    lm_miles_currently_vehicle: '',
    lm_selling_price: '',
    lm_cap_cost_reduction: '',
    lm_total_capitalized_cost: '',
    lm_base_monthly_payment: '',
    lm_tax_on_payment: '',
    lm_total_monthly_payment: '',
    lm_original_lease_term: '',
    lm_num_payments_in_advance: '',
    lm_remaining_payments: '',
    lm_residual_at_end_of_term: '',
    lm_advance_rental_payments: '',
    lm_tax_due_at_inception: '',
    lm_lease_acquisition_fee: '',
    lm_service_contract_fee: '',
    lm_dealer_fees: '',
    lm_tax_on_fees: '',
    lm_est_1year_taxtitlereg_fees: '',
    lm_security_deposit: '',
    lm_other: '',
    lm_total_due_at_signing: '',
    lm_less_tradein_allowance: '',
    lm_less_dealer_deposit: '',
    lm_cash_due_at_signing: '',
    lm_advance_made_signing: '',
    street1: '',
    street2: '',
    city: '',
    zip_code: '',
    state_fips_c: '',
    country: '',
    work_number: '',
    mobile_number: '',
    fax_number: '',
    email: '',
    inactive_d: '',
    creation_user_i: '',
    created_at: '',
    last_updated_user_i: '',
    last_updated_at: '',
    customer_id: '',
    inhouse_category: '',
    employee_id: '',
    dealer_id: '',
    business_contact_full_name: '',
    tabIndex: '',
    id: '',
    de_Is_Sale_Leaseback: '',
    de_is_deferred_down: '',
    de_initial_equity_target: '',
    de_secondary_equity_build: 0,
    de_equity_build_period: '',
    de_deferred_equity_amount: 0,
    de_monthly_equity_build_payment: '',
    de_tax_on_monthly_equity_build_payment: '',
    de_total_monthly_equity_build_payment: '',
    de_first_12months_payment_amount: '',
    de_total_pre_tax_build_payments: '',
    de_total_equity_build_payments: '',
    // International autosource program elements
    is_ias_deal: '',
    ias_program: '',
    ias_rev_share: '',
    ias_llp_rate: '',
    ias_upfront: '',
    ias_pro_formaforma_to_llp: '',
    ias_monthly_ias_rev_share: '',
    pd_is_portfolio_deal: '',
    pd_existing_lease_balances: '',
    pd_existing_collateral_value: '',
    pd_post_deal_equity: '',
    // Reg M Threshold Check
    lm_reg_m_threshold: '',
    first_year_loan_payment: ''
  },
  quotegeneration: {
    hours: 0,
    minutes: 0,
    seconds: 0,
    counter: 0
  },
  marketvalue: [
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    },
    {
      manheimdata: [{ mmr: 0, comp1: 0, comp2: 0, comp3: 0, comp4: 0, comp5: 0, comp6: 0 }],
      blackbook: [{ excellent: 0, good: 0, fair: 0 }],
      baseevaluation: [{ base_evaluation: 0 }],
      judgmentaladjustments: [{ equipment: 0, market: 0, other: 0 }],
      finalevaluation: [{ final_valuation: 0 }],
      valuationcommentary: [{ valuation_commentary: 0 }]
    }
  ]
}
